var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBondContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7282 43.2767L52.7217 46.4257C56.6682 47.2055 59.6107 50.071 60.4849 54L64.9752 74.212H33.0236L11.4233 79.2339L8.98319 74.2118H1.06619L5.56236 53.9998C6.43682 50.0708 9.37319 47.2053 13.3256 46.4255L29.3193 43.2767C31.8835 42.7685 34.164 42.7685 36.7282 43.2767Z",
    fill: "#EC5A6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09271 70.2947L16.4454 73.6741C18.2238 74.3121 19.5944 75.5884 20.4039 77.1423L11.4233 79.2338L8.98319 74.2118H1.06619L1.91708 70.3951C3.51243 69.7512 5.34969 69.6626 7.09271 70.2947Z",
    fill: "#D62F45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17114 72.8414L15.5238 76.2208C17.8695 77.0656 19.0925 79.6772 18.2475 82.0227C17.4025 84.3682 14.7914 85.5912 12.4457 84.7464L3.09298 81.3611C0.747293 80.5163 -0.475723 77.9047 0.369277 75.5592C1.21407 73.2194 3.82545 71.9964 6.17114 72.8414Z",
    fill: "#FFC7AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9548 70.2947C60.6978 69.6626 62.5292 69.7512 64.1304 70.3951L64.9754 74.2118H48.4325C48.7987 74.005 49.1887 73.8218 49.5964 73.6741L58.9548 70.2947Z",
    fill: "#D62F45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8764 72.8414L50.5178 76.2208C48.1721 77.0656 46.9491 79.6772 47.7941 82.0227C48.645 84.3682 51.2562 85.5912 53.596 84.7464L62.9545 81.3611C65.2941 80.5163 66.5232 77.9047 65.6723 75.5592C64.8275 73.2194 62.2162 71.9964 59.8764 72.8414Z",
    fill: "#FFC7AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9685 86.5127H56.3375V93.0413H10.9685V86.5127Z",
    fill: "#6BA7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6501 86.5127H15.0627C12.8117 86.5127 10.9683 84.6693 10.9683 82.4183V62.4605C10.9683 59.8253 13.1249 57.6689 15.7599 57.6689H33.6499H51.5458C54.181 57.6689 56.3373 59.8255 56.3373 62.4605V82.4183C56.3373 84.6693 54.494 86.5127 52.237 86.5127H33.6501Z",
    fill: "#C4E1FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6768 38.4673H38.3707V43.6252L33.0239 48.5703L27.6768 43.6252V38.4673Z",
    fill: "#FFAA7B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6692 4.02246C41.9333 4.02246 49.4426 11.5259 49.4426 20.79C49.4426 21.8654 49.3362 22.9169 49.1412 23.9391C48.4794 23.5373 47.7055 23.3069 46.8784 23.3069H19.163C18.07 23.3069 17.0655 23.7146 16.2916 24.3823C16.0375 23.2243 15.9018 22.0189 15.9018 20.79C15.9018 11.5259 23.4112 4.02246 32.6692 4.02246Z",
    fill: "#945230"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.103394 93.041H103.898V101.218H0.103394V93.041Z",
    fill: "#FFD496"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8006 79.1924H103.898V93.0412H70.8006V79.1924Z",
    fill: "#4C6CB5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8006 65.3379H103.898V79.1926H70.8006V65.3379Z",
    fill: "#3B5892"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6587 51.1105C90.9419 51.1105 100.956 41.0902 100.956 28.8072C100.956 16.5299 90.9417 6.50977 78.6587 6.50977C66.3756 6.50977 56.3552 16.5299 56.3552 28.8072C56.3552 41.0904 66.3756 51.1105 78.6587 51.1105Z",
    fill: "#6BA7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6587 45.557C87.8814 45.557 95.4025 38.0356 95.4025 28.8073C95.4025 19.5846 87.8814 12.0635 78.6587 12.0635C69.4302 12.0635 61.909 19.5846 61.909 28.8073C61.909 38.0359 69.4302 45.557 78.6587 45.557Z",
    fill: "#E9EEF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6585 19.1177C79.4645 19.1177 80.118 18.4643 80.118 17.6585V15.886C80.118 15.08 79.4645 14.4268 78.6585 14.4268C77.8525 14.4268 77.1991 15.0802 77.1991 15.886V17.6585C77.1993 18.4645 77.8525 19.1177 78.6585 19.1177Z",
    fill: "#506480"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5006 20.417C83.7304 20.5496 83.9812 20.6126 84.2284 20.6126C84.733 20.6126 85.2237 20.3506 85.4939 19.8824L86.3801 18.3461C86.7829 17.648 86.5436 16.7555 85.8455 16.3529C85.1472 15.9499 84.2548 16.1895 83.8522 16.8875L82.966 18.4237C82.5632 19.1219 82.8025 20.0142 83.5006 20.417Z",
    fill: "#506480"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3141 24.6952C88.5613 24.6952 88.8121 24.6322 89.0419 24.4996L90.5781 23.6134C91.2762 23.2106 91.5155 22.3182 91.1127 21.6201C90.7101 20.9222 89.8178 20.6821 89.1195 21.0855L87.5832 21.9717C86.8851 22.3745 86.6458 23.2668 87.0486 23.965C87.3188 24.4334 87.8095 24.6952 88.3141 24.6952Z",
    fill: "#506480"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5799 27.3481H89.8074C89.0014 27.3481 88.348 28.0016 88.348 28.8074C88.348 29.6132 89.0014 30.2666 89.8074 30.2666H91.5799C92.3859 30.2666 93.0394 29.6132 93.0394 28.8074C93.0394 28.0016 92.3859 27.3481 91.5799 27.3481Z",
    fill: "#506480"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5781 34.0067L89.0419 33.1204C88.3433 32.7174 87.4512 32.9571 87.0486 33.6551C86.6458 34.3532 86.8851 35.2457 87.5832 35.6483L89.1195 36.5346C89.3492 36.6672 89.6001 36.7302 89.8473 36.7302C90.3518 36.7302 90.8426 36.4681 91.1127 35.9999C91.5155 35.3018 91.2762 34.4095 90.5781 34.0067Z",
    fill: "#506480"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4939 37.7377C85.0913 37.0397 84.199 36.7998 83.5006 37.203C82.8025 37.6058 82.5632 38.4982 82.966 39.1963L83.8522 40.7325C84.1224 41.201 84.6131 41.4628 85.1177 41.4628C85.3649 41.4628 85.6158 41.3998 85.8455 41.2672C86.5436 40.8644 86.7829 39.972 86.3801 39.2739L85.4939 37.7377Z",
    fill: "#506480"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6585 38.5024C77.8525 38.5024 77.1991 39.1559 77.1991 39.9617V41.7342C77.1991 42.5402 77.8525 43.1934 78.6585 43.1934C79.4645 43.1934 80.118 42.54 80.118 41.7342V39.9617C80.118 39.1559 79.4645 38.5024 78.6585 38.5024Z",
    fill: "#506480"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8105 37.2034C73.1122 36.8004 72.2199 37.0403 71.8173 37.738L70.931 39.2743C70.5282 39.9724 70.7675 40.8649 71.4657 41.2675C71.6954 41.4002 71.9463 41.4631 72.1935 41.4631C72.698 41.4631 73.1888 41.2011 73.4589 40.7329L74.3452 39.1967C74.7482 38.4985 74.5087 37.606 73.8105 37.2034Z",
    fill: "#506480"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2697 33.1204L66.7333 34.0067C66.0351 34.4095 65.7956 35.3018 66.1984 35.9999C66.4686 36.4683 66.9593 36.7304 67.4639 36.7304C67.7111 36.7304 67.962 36.6674 68.1915 36.535L69.7279 35.6487C70.4261 35.2459 70.6656 34.3536 70.2628 33.6555C69.8602 32.9571 68.9676 32.7174 68.2697 33.1204Z",
    fill: "#506480"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9693 28.8074C68.9693 28.0014 68.3158 27.3481 67.5098 27.3481H65.7315C64.9255 27.3481 64.272 28.0016 64.272 28.8074C64.272 29.6132 64.9255 30.2666 65.7315 30.2666H67.5098C68.316 30.2666 68.9693 29.6132 68.9693 28.8074Z",
    fill: "#506480"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7279 21.9715L68.1915 21.0852C67.4938 20.6822 66.601 20.9221 66.1984 21.6201C65.7956 22.3182 66.0351 23.2107 66.7333 23.6133L68.2697 24.4996C68.4992 24.632 68.7501 24.695 68.9973 24.695C69.5018 24.695 69.9926 24.4329 70.2628 23.9645C70.6658 23.2666 70.4261 22.3743 69.7279 21.9715Z",
    fill: "#506480"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4591 16.8876C73.0565 16.1895 72.1642 15.9498 71.4659 16.353C70.7677 16.7558 70.5285 17.6481 70.9313 18.3463L71.8175 19.8825C72.0876 20.3509 72.5784 20.6127 73.083 20.6127C73.3302 20.6127 73.581 20.5498 73.8108 20.4171C74.5089 20.0143 74.7482 19.122 74.3454 18.4239L73.4591 16.8876Z",
    fill: "#506480"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1488 27.4129L80.118 27.3626V22.3025C80.118 21.4965 79.4645 20.8433 78.6585 20.8433C77.8525 20.8433 77.1991 21.4967 77.1991 22.3025V28.8074C77.1991 29.6077 77.8438 30.2587 78.6439 30.2666L85.1193 30.3316H85.1342C85.9332 30.3316 86.5853 29.6877 86.5932 28.887C86.6015 28.081 85.9546 27.4211 85.1488 27.4129Z",
    fill: "#506480"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4768 57.6689H51.546C54.1811 57.6689 56.3375 59.8255 56.3375 62.4605V82.4183C56.3375 84.6693 54.4942 86.5127 52.2372 86.5127H47.1739C49.425 86.5127 51.2683 84.6693 51.2683 82.4183V62.4605C51.2681 59.8253 49.1118 57.6689 46.4768 57.6689Z",
    fill: "#9CC3ED"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0305 86.5127H56.3373V93.0413H48.0305V86.5127Z",
    fill: "#4888E8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1453 65.3379H103.898V79.1926H97.1453V65.3379Z",
    fill: "#2D477A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1453 79.1924H103.898V93.0412H97.1453V79.1924Z",
    fill: "#3B5892"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1453 93.041H103.898V101.218H97.1453V93.041Z",
    fill: "#EDB668"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6692 4.02246C41.9333 4.02246 49.4426 11.5259 49.4426 20.79C49.4426 21.8654 49.3362 22.9169 49.1412 23.9391C48.4794 23.5373 47.7055 23.3069 46.8784 23.3069H44.84C44.9642 22.4857 45.0292 21.6468 45.0292 20.79C45.0292 12.2762 38.6837 5.24548 30.4655 4.16424C31.1862 4.06979 31.9247 4.02246 32.6692 4.02246ZM19.163 23.3067C18.07 23.3067 17.0655 23.7144 16.2916 24.3821C16.2149 24.0274 16.1499 23.6671 16.0907 23.3067H19.163Z",
    fill: "#753616"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.163 23.3066H46.8784C49.3068 23.3066 51.2919 25.2918 51.2919 27.7143C51.2919 30.1426 49.3068 32.1278 46.8784 32.1278H19.163C16.7407 32.1278 14.7554 30.1426 14.7554 27.7143C14.7556 25.2918 16.7407 23.3066 19.163 23.3066Z",
    fill: "#FFAA7B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0292 21.9006V29.4513C45.0292 36.0565 39.6291 41.4625 33.0237 41.4625C26.4182 41.4625 21.0123 36.0565 21.0123 29.4513V21.7765C22.0344 22.0247 23.1038 22.1545 24.2028 22.1545C28.9648 22.1545 34.3885 19.5904 37.6852 16.4473C38.0693 19.2301 40.663 22.1073 43.5876 22.1073C44.0897 22.1073 44.5744 22.0365 45.0292 21.9006Z",
    fill: "#FFC7AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBondContracts);
export default __webpack_public_path__ + "static/media/no-bond-contracts.48d324f0024cd98b58173b9d3324e0a8.svg";
export { ForwardRef as ReactComponent };